(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropostareceituarioAprovarDialogController', PropostareceituarioAprovarDialogController);

    PropostareceituarioAprovarDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Propostareceituario', 'Propriedade', 'Safra', 'Atributo', 'Concentracaoidealatributo', 'Concentracaoindice', 'Imagemtermica', 'Mapaimagem', 'Receituario', 'Atividade', 'Quadrantesolo'];

    function PropostareceituarioAprovarDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Propostareceituario, Propriedade, Safra, Atributo, Concentracaoidealatributo, Concentracaoindice, Imagemtermica, Mapaimagem, Receituario, Atividade, Quadrantesolo) {
        var vm = this;
        vm.propostareceituario = entity;
        vm.clear = clear;
        vm.onSaveError = onSaveError;
        vm.onSaveSuccess = onSaveSuccess;
        vm.aprovacao = aprovacao;
        vm.atividades = Atividade.query();
        vm.receituario = new Receituario();
        vm.separar = separar;

        vm.receituario.quantidade = vm.propostareceituario.quantidadesubstancia;
        vm.receituario.medidaquantidade = 'kg';

        function separar(ponto, indice){
            ponto = ponto.slice(1, -1);
            var vetor = ponto.split(',');
            console.log(vetor[indice]);
            return vetor[indice];
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function aprovacao(id){
            vm.novoReceituario = new Receituario();
            vm.novoReceituario.diagnostico = vm.receituario.diagnostico;
            vm.novoReceituario.produto = vm.receituario.produto;
            vm.novoReceituario.quantidade = vm.receituario.quantidade;
            vm.novoReceituario.medidaquantidade = vm.receituario.medidaquantidade;
            vm.novoReceituario.aplicacao = vm.receituario.aplicacao;
            vm.novoReceituario.posaplicacao = vm.receituario.posaplicacao;
            vm.novoReceituario.propostareceituario = new Propostareceituario();
            vm.novoReceituario.propostareceituario = vm.propostareceituario;
            vm.novoReceituario.latitudeespecifica = vm.separar(vm.propostareceituario.ponto1, 0);
            vm.novoReceituario.longitudeespecifica = vm.separar(vm.propostareceituario.ponto1, 1);
            vm.novoReceituario.atividade = new Atividade();
            vm.novoReceituario.atividade = vm.receituario.atividade;

            console.log(vm.novoReceituario);

            Receituario.save(vm.novoReceituario, onSaveSuccess, onSaveError);
        }
        
        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:propostareceituarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
